export enum MatchCommentEditBucket {
  Unchanged = 'unchanged',
  Light = 'light',
  Heavy = 'heavy',
  Rewritten = 'rewritten',
}
